import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceData } from '../models/reference-data.model';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({ name: 'localizeOptionListFilteredByAttribute' })
export class LocalizeOptionListFilteredByAttributePipe implements PipeTransform {
  constructor(private referenceDataService: ReferenceDataService) {}

  transform(id: string, excludeAttribute: string): Array<ReferenceData> {
    return this.referenceDataService.getFilteredOptionListConfigItems(id, excludeAttribute);
  }
}
